import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO52 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK005-2.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO52
